import request, { AxiosResult } from "api/request2";
import {
  LeavesReviewQuery,
  LeavesReviewResponse,
  UsersSearchResponse,
} from "./types";

const LEAVES_REVIEW_ADMIN = {
  USERS: "/admin/leaves/users",
  DATA: (userId: string) => `/admin/leaves/${userId}`,
};

/**
 * Obtiene la información de permisos/vacaciones de un funcionario específico
 * Envia opcionalmente la fecha de referencia como query param (?date=YYYY-MM-DD)
 */
export async function fetchLeavesReview(
  query: LeavesReviewQuery
): Promise<AxiosResult<LeavesReviewResponse>> {
  if (!query.userId) {
    const empty: LeavesReviewResponse = {
      permissionsStatus: {
        p_disponibles: 0,
        p_cod_error: "NO_USER",
        p_det_error: null,
      },
      holidaysStatus: {
        p_periodo: 0,
        p_zona: 0,
        p_antiguedad: 0,
        p_progresivo: 0,
        p_tomados_periodo: 0,
        p_interrumpidos: 0,
        p_acumulados: 0,
        p_transferidos: 0,
        p_adelantados: 0,
        p_disponibles: 0,
        p_cod_error: "NO_USER",
        p_det_error: null,
      },
      registereds: [],
      requests: [],
      authorizers: [],
      leaveGroups: [],
      user: null,
      date: query.date ? query.date.toISOString() : null,
    };
    return Promise.resolve({ data: empty, error: false, status: 200 });
  }

  const params = query.date
    ? { date: query.date.toISOString().substring(0, 10) }
    : undefined;

  const res = await request<LeavesReviewResponse>(
    LEAVES_REVIEW_ADMIN.DATA(query.userId),
    {
      method: "GET",
      params,
    }
  );
  if (!res.error && res.data) {
    res.data.user = query.userId;
    res.data.date = query.date ? query.date.toISOString() : null;
  }
  return res;
}

/**
 * Lista de usuarios disponible para el módulo admin
 */
export function fetchAllUsers(): Promise<AxiosResult<UsersSearchResponse>> {
  return request<UsersSearchResponse>(LEAVES_REVIEW_ADMIN.USERS, {
    method: "GET",
  });
}
